module.exports = __webpack_public_path__ + "img/KCL_box_red_485_rgb.6ae02c40.jpg";